import { Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { submitForReview } from '../../../../../redux/slices/invoicing';
import { useDispatch } from '../../../../../redux/store';
import { AwaitButton } from '../../../../../reusable-components/await-button';
import Iconify from '../../../../../reusable-components/iconify';
import { useCanSubmitInvoice } from '../reusable/hooks/useInvoiceLocks';

SubmitForReview.propTypes = {
  unsavedData: PropTypes.object,

  glRows: PropTypes.any,
  goToNext: PropTypes.func,
  withDuplicateCheck: PropTypes.func,
};
export default function SubmitForReview({ unsavedData, glRows, goToNext, withDuplicateCheck }) {
  const { id } = useParams();

  const dispatch = useDispatch();
  const { canSubmit, message } = useCanSubmitInvoice(glRows, unsavedData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async () => {
    await dispatch(submitForReview(id));
    goToNext();
    setIsSubmitting(false);
  };
  useEffect(() => {
    if (Object.values(unsavedData)?.length === 0 && isSubmitting) {
      submit();
    }
  }, [unsavedData, isSubmitting]);
  const save = async () => {
    withDuplicateCheck(async () => {
      if (Object.values(unsavedData)?.length > 0) return;
      setIsSubmitting(true);
    }, 'Send for Review');
  };

  return (
    <>
      <Tooltip
        title={
          !canSubmit ? (
            message
          ) : (
            <>
              Moves this invoice from <em>New Invoices</em> to <em>Pending</em>, where authorized users can review and
              submit
            </>
          )
        }
        placement="top"
        arrow
      >
        <Box>
          <AwaitButton
            variant="contained"
            color="secondary"
            onClick={save}
            loading={isSubmitting}
            loadingPosition="start"
            disabled={!canSubmit}
            startIcon={<Iconify icon="material-symbols:rate-review-outline" />}
            size="small"
          >
            Ready for Review
          </AwaitButton>
        </Box>
      </Tooltip>
    </>
  );
}
